import React from 'react';
import { FaCheck } from 'react-icons/fa';
import {
	GiScalpel, GiKidneys, GiLips, GiSkullCrossedBones, GiHeartOrgan,
	GiStomach, GiLungs, GiIntestines, GiBrain, GiMicroscope,
} from 'react-icons/gi';
import {
	FaUserMd, FaBaby, FaEye, FaHeadSideCough, FaFemale,
	FaBone, FaTooth, FaStethoscope, FaRibbon, FaChild,
	FaNotesMedical, FaXRay, FaAllergies, FaSyringe,
} from 'react-icons/fa';
import { MdPsychology, MdHearing } from 'react-icons/md';
import './index.css';

const specialities = [
	{ name: 'General Surgery',        icon: <GiScalpel /> },
	{ name: 'Urology',                icon: <GiKidneys /> },
	{ name: 'Plastic Surgery',        icon: <GiLips /> },
	{ name: 'Maxillo-Facial Surgery', icon: <GiSkullCrossedBones /> },
	{ name: 'Cardiothoracic Surgery', icon: <GiHeartOrgan /> },
	{ name: 'Endocrinology',          icon: <FaNotesMedical /> },
	{ name: 'Pulmonology',            icon: <GiLungs /> },
	{ name: 'Gastroenterology',       icon: <GiStomach /> },
	{ name: 'Dermatology',            icon: <FaAllergies /> },
	{ name: 'Nephrology',             icon: <GiKidneys /> },
	{ name: 'Allergology',            icon: <FaSyringe /> },
	{ name: 'Pediatric Surgery',      icon: <FaBaby /> },
	{ name: 'Psychiatry',             icon: <MdPsychology /> },
	{ name: 'Anaesthesia',            icon: <FaSyringe /> },
	{ name: 'Ophthalmology',          icon: <FaEye /> },
	{ name: 'ENT',                    icon: <MdHearing /> },
	{ name: 'Gynaecology',            icon: <FaFemale /> },
	{ name: 'Neurosurgery',           icon: <GiBrain /> },
	{ name: 'Orthopaedics',           icon: <FaBone /> },
	{ name: 'Dentistry',              icon: <FaTooth /> },
	{ name: 'Internal Medicine',      icon: <FaStethoscope /> },
	{ name: 'Cardiology',             icon: <GiHeartOrgan /> },
	{ name: 'Oncology',               icon: <FaRibbon /> },
	{ name: 'Paediatrics',            icon: <FaChild /> },
	{ name: 'Neurology',              icon: <GiBrain /> },
	{ name: 'Radiology',              icon: <FaXRay /> },
];

const ClinicAndSpecialities = () => {
	return (
		<section className="specialities-section">
			<div className="container">
				<div className="specialities-header text-center">
					<span className="specialities-label">Our focus</span>
					<h2>Specialities</h2>
					<span className="specialities-header-line" aria-hidden="true" />
					<p className="specialities-lead">
						Expert care across multiple specialties under one roof.
					</p>
				</div>
				<div className="specialities-grid">
					{specialities.map((item) => (
						<div className="speciality-card" key={item.name}>
							<div className="speciality-card-inner">
								<div className="speciality-img-wrap">
									<span className="speciality-img-ring" aria-hidden="true" />
									<span className="speciality-icon">{item.icon}</span>
									<span className="speciality-check">
										<FaCheck />
									</span>
								</div>
								<p className="speciality-name">{item.name}</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default ClinicAndSpecialities;
